// The "last account you were in" memory, scoped PER WORKSPACE. Account ids belong
// to one workspace, so remembering a single global id leaked the previous
// agency's account into another agency after a switch (or a fresh tab).
const PREFIX = "flowio-last-account-id";
// Builds before per-workspace scoping stored one value under the bare key. It
// can't be attributed to a workspace, so it's dropped rather than guessed.
const LEGACY_KEY = PREFIX;

export const lastAccountKey = (ws: string) => `${PREFIX}:${ws}`;

export function readLastAccount(ws: string | null | undefined): number | null {
  if (!ws) return null;
  try {
    localStorage.removeItem(LEGACY_KEY);
    const v = localStorage.getItem(lastAccountKey(ws));
    const n = v ? parseInt(v, 10) : NaN;
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch { return null; }
}

export function writeLastAccount(ws: string | null | undefined, id: number | null): void {
  if (!ws) return;
  try {
    if (id) localStorage.setItem(lastAccountKey(ws), String(id));
    else localStorage.removeItem(lastAccountKey(ws));
  } catch { /* storage unavailable: memory only */ }
}
